import { render, staticRenderFns } from "./learn-pathed.vue?vue&type=template&id=4222c2f4&scoped=true&"
import script from "./learn-pathed.vue?vue&type=script&lang=js&"
export * from "./learn-pathed.vue?vue&type=script&lang=js&"
import style0 from "./learn-pathed.vue?vue&type=style&index=0&id=4222c2f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4222c2f4",
  null
  
)

export default component.exports